//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'stepper',
  props: {
    value: Number,
    maxVal: {
      type: Number,
      default: Infinity
    },
    minVal: {
      type: Number,
      default: 1
    },
    isDisabled: Boolean
  },
  data() {
    return {
      number: this.value
    }
  },
  watch: {
    number(val, oldVal) {
      this.$emit('input', this.number)
      this.$emit('change', this.number, oldVal)
    }
  },
  methods: {
    minus() {
      if (!this.isDisabled && this.number > this.minVal) {
        --this.number
      } else {
        this.$emit('minus-error')
      }
    },
    plus() {
      if (!this.isDisabled && this.number < this.maxVal) {
        ++this.number
      } else {
        this.$emit('plus-error')
      }
    }
  }
}
